import {
    GET_AIR_QUALITY_FORECAST_BY_LATLON_FULFILLED,
    GET_AIR_QUALITY_FORECAST_BY_LATLON_PENDING,
    GET_AIR_QUALITY_FORECAST_BY_LATLON_REJECTED,
    GET_CURRENT_AIR_QUALITY_BY_LATLON_FULFILLED,
    GET_CURRENT_AIR_QUALITY_BY_LATLON_PENDING,
    GET_CURRENT_AIR_QUALITY_BY_LATLON_REJECTED,
    REFRESH_AIR_QUALITY_FORECAST_BY_LATLON_FULFILLED,
    REFRESH_AIR_QUALITY_FORECAST_BY_LATLON_PENDING,
    REFRESH_AIR_QUALITY_FORECAST_BY_LATLON_REJECTED,
    REFRESH_CURRENT_AIR_QUALITY_BY_LATLON_FULFILLED,
    REFRESH_CURRENT_AIR_QUALITY_BY_LATLON_PENDING,
    REFRESH_CURRENT_AIR_QUALITY_BY_LATLON_REJECTED
} from '../actions/airQualityActions.js';

import { LOCATION_CHANGED } from '../actions/locationActions';

const initialState = {
    currentAirQualityIsRefreshing: false,
    forecastIsRefreshing: false
};

export function airQuality(state = initialState, action)
{
    switch (action.type)
    {
        case LOCATION_CHANGED:
        {
            return initialState;
        }
        case GET_CURRENT_AIR_QUALITY_BY_LATLON_PENDING:
        {
            return {
                ...state,
                currentAirQualityIsFetching: true
            };
        }
        case GET_CURRENT_AIR_QUALITY_BY_LATLON_FULFILLED:
        {
            return {
                ...state,
                currentAirQuality: action.payload,
                lastError: {},
                currentAirQualityIsFetching: false
            };
        }

        case GET_CURRENT_AIR_QUALITY_BY_LATLON_REJECTED:
        {
            return {
                ...state,
                currentAirQuality: undefined,
                lastError: action.payload,
                currentAirQualityIsFetching: false
            };
        }

        case REFRESH_CURRENT_AIR_QUALITY_BY_LATLON_PENDING:
        {
            return {
                ...state,
                currentAirQualityIsRefreshing: true
            };
        }

        case REFRESH_CURRENT_AIR_QUALITY_BY_LATLON_FULFILLED:
        {
            return {
                ...state,
                currentAirQuality: action.payload,
                lastError: {},
                currentAirQualityIsRefreshing: false
            };
        }

        case REFRESH_CURRENT_AIR_QUALITY_BY_LATLON_REJECTED:
        {
            return {
                ...state,
                currentAirQuality: undefined,
                lastError: action.payload,
                currentAirQualityIsRefreshing: false
            };
        }

        case GET_AIR_QUALITY_FORECAST_BY_LATLON_PENDING:
        {
            return {
                ...state,
                airQualityForecastIsFetching: true
            };
        }

        case GET_AIR_QUALITY_FORECAST_BY_LATLON_FULFILLED:
        {
            return {
                ...state,
                forecast: action.payload,
                lastForecastError: undefined,
                airQualityForecastIsFetching: false
            };
        }

        case GET_AIR_QUALITY_FORECAST_BY_LATLON_REJECTED:
        {
            return {
                ...state,
                forecast: [],
                lastForecastError: action.payload,
                airQualityForecastIsFetching: false
            };
        }

        case REFRESH_AIR_QUALITY_FORECAST_BY_LATLON_PENDING:
        {
            return {
                ...state,
                forecastIsRefreshing: true
            };
        }

        case REFRESH_AIR_QUALITY_FORECAST_BY_LATLON_FULFILLED:
        {
            return {
                ...state,
                forecast: action.payload,
                lastForecastError: undefined,
                forecastIsRefreshing: false
            };
        }

        case REFRESH_AIR_QUALITY_FORECAST_BY_LATLON_REJECTED:
        {
            return {
                ...state,
                forecast: [],
                lastForecastError: action.payload,
                forecastIsRefreshing: false
            };
        }
    }

    return state;
}
